<template>
  <div class="my">
    <div class="my-head">个人中心</div>
    <div class="text1">基本设置</div>
    <div class="text2">当前近级别：{{level?level:'暂无'}}</div>
    <div class="text2">认证个人信息：<el-button size="mini" disabled>已完成</el-button></div>
    <div class="text2">修改密码：<el-button size="mini" type="primary" @click="show=true">修改</el-button></div>
    <el-dialog title="修改密码" :visible.sync="show" width="30%">
      <div>
        <el-form ref="form" :model="form" label-width="0px">
          <el-form-item>
            <el-input placeholder="请输入密码" show-password prefix-icon="el-icon-unlock" v-model="form.password" />
          </el-form-item>
          <el-form-item >
            <el-input placeholder="请确认密码" show-password prefix-icon="el-icon-unlock" v-model="form.password1" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="xiugai()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {api7} from '@/api/index.js'
export default {
  data () {
    return {
      show: false,
      form: {
        password: '',
        password1: ''
      }
    }
  },
  props:['level'],
  watch:{
    show() {
      this.form = {
        password: '',
        password1: ''
      }
    }
  },
  mounted () {

  },
  methods: {
    xiugai () {
      api7({
        id: JSON.parse(localStorage.getItem('userInfo')).id,
        password: this.form.password,
        password_confirm: this.form.password1
      }).then(res => {
        if (res.data.code === 1) {
          this.show = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }

}
</script>

<style>
  .text2{
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    margin-top: 24px;
  }
  .text1{
    font-weight: bold;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    margin-top: 24px;
  }
  .my-head{
    height: 40px;
    line-height: 40px;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    display: flex;
    background:#fff;
    margin-bottom:1px;
    border-bottom: 1px solid #F6F6F6;
  }
  .my{
    /* width: 100%;
    height: 100%; */
    padding:16px 24px;
    box-sizing: border-box;
    background:#fff;
    overflow: hidden;
    overflow-y: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cmy.vue